import { useState } from "react";
import GamingPopup from "./GamingPopup";

/**
 * Button/control that opens the sitewide Coming Soon modal
 * for features that do not have a live page yet.
 */
const ComingSoonButton = ({
  title = "This feature",
  className = "",
  children,
  as: Comp = "button",
  type,
  ...rest
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Comp
        type={Comp === "button" ? type || "button" : type}
        className={className}
        onClick={() => setOpen(true)}
        {...rest}
      >
        {children}
      </Comp>
      <GamingPopup
        open={open}
        title={title}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default ComingSoonButton;
